// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';

import ForgotPassword from './Modals/ForgotPassword';
import VerifyLogin from './Modals/VerifyLogin';
import DefaultNav from './DefaultNav';
import api from '../api';

import '../styles/login.css';
import { datadogRum } from '@datadog/browser-rum';

export default class Login extends React.Component {

    state = {
        email: "",
        password: "",
        modal: "",
        userId: "",
        method: "",
        usingSSO: true, 
        stage: "email" // email, password
    }

    attemptLogin = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Are we still on the email stage? check if we are using sso... 
        if(this.state.stage === 'email'){
            const res = await api.get('/user/exists?email=' + this.state.email);
            if(!res || !res.success || !res.user || !res.user._id){
                toast.error("No user exists with that email.");
                return; 
            }

            const user = res.user; 
            this.setState({
                userId: user._id, 
                team: user.team
            })

            if(!user?.sso?.enabled){
                this.setState({
                    stage: 'password'
                })
                return; 
            }
            
            return window.location.href = api.apiUrl + '/user/login/sso/' + user.team + "?redirect=true"
        }

        await this.props.loading(1005);

        let { email, password } = this.state;
        email = email.trim();
        const persist = this.props.persist

        const res = await api.post('/user/login', { email, password, persist });

        if(!res || !res.success){
            this.props.loaded(); 
            return
        }

        
        if(res.user && res.team){
            localStorage.setItem("userLoggedIn",true)
            toast.info("Welcome back, " + res.user.name + "!");
            this.props.login(res.user, res.team);

            const query = new URLSearchParams(this.props.location.search);
            const redirect = query.get('redirect');
            const exchange = query.get('exchange');

            window.location.href = redirect && redirect !== "" ? (redirect + (exchange ? "?code=" + res.code : "")) : "/";
        }  else if (res.userId && ["email", "sms"].includes(res.twoFactorAuth))
                this.setState({
                    modal: "verify-code",
                    method: res.twoFactorAuth,
                });

        else toast.error("Uh Oh! Your team's preferred two-factor authentication method is not currently supported. Please contact your team administrator.");

        this.props.loaded();
        await this.setState({ password: "" });

    }

    componentDidMount = async () => {
        const query = new URLSearchParams(this.props.location.search);
        const errorLogin = query.get('error');

        // If login fails, should show a toast wtih the error message
        if(errorLogin && errorLogin !== "")
            toast.error(errorLogin);

        this.props.reset();
        await api.get('/user/logout');
        datadogRum.clearAccount();
        datadogRum.clearUser(); 
    }

    render = () => {
        return (<>
            <div className="login-graphic-container">
                <div className="login-graphic-content">
                    <h1>TAILORED FOR TPAs</h1>
                    <h1>Engineered for Productivity</h1>
                </div>
            </div>

            <div className="login-container">

                <DefaultNav />

                <form
                    className="login-form"
                    onSubmit={async(e) => {
                        e.preventDefault(); 
                        e.stopPropagation(); 
                        this.attemptLogin(e); 
                    }}
                >
                    
                    <h1><div className="login-title">WELC</div>OME BACK!</h1>
                    
                    {this.state.stage === 'email' &&
                    <>
                        <label>Email</label>
                        <input
                            style={{ 
                                marginTop: 2,
                                paddingRight: 50,
                            }}
                            id="email"
                            name="email"
                            type="text"
                            placeholder=""
                            value={this.state.email}
                            onChange={e => this.setState({ email: e.target.value })}
                            autoFocus
                        />
                    </>}

                    {this.state.stage === 'password' &&
                    <>

                        <label style={{ marginBottom: 24 }}>
                            Logging in as 
                            <span> {this.state.email},</span>
                            <span 
                                className='a'
                                onClick={() => this.setState({ stage: 'email' })}
                            > Not you?</span>
                        </label>

                        <label>Password</label>
                        <input
                            style={{ marginTop: 2 }}
                            id="password"
                            name="password"
                            type="password"
                            placeholder=""
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                            autoFocus
                        />
                        <div style={{ padding: '0 2px', marginTop: 5 }}>
                            <label
                                className="checkbox"
                                title="Keep me logged in for 30 days."
                            >Remember me
                                <input
                                    type="checkbox"
                                    checked={this.props.persist}
                                    onChange={() => this.props.updatePersist(!this.props.persist)}
                                />
                                <span className="checkmark" />
                            </label>

                            <div style={{ clear: 'both' }} />

                            <div
                                className="forgotPassword"
                                onClick={() => this.setState({ modal: "forgot-password" })}
                            >Forgot password?</div>
                        </div>
                    </>}


                    <input
                        type="submit"
                        value={this.state.stage === 'email' ? "Next" : "Login"}
                        style={{marginBottom: 50}}
                    />
                </form>
            </div>

            {this.state.modal === "forgot-password" ? <ForgotPassword
                modal={() => this.setState({ modal: "" })}
                loading={this.props.loading}
                loaded={this.props.loaded}
            /> :
            
            this.state.modal === "verify-code" ? <VerifyLogin
                modal={() => this.setState({ modal: "" })}
                userId={this.state.userId}
                team={this.state.team}
                persist={this.props.persist}
                login={this.props.login}
                method={this.state.method}
                switchingTeam={false}
                resendCode={this.attemptLogin}
                loading={this.props.loading}
                loaded={this.props.loaded}
            /> : ""}

        </>);
    }

}